/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import React from "react";
import { isFeatureEnabled } from "utility/isFeatureEnabled";

import { isDisplayPeriod } from "../../../../utility";
import {
  canWatchVideo,
  extractDefaultVideoId,
} from "../../../../utility/streaming";
import { LiveListItemCaution } from "./LiveListItemCaution";
import { LiveListItemPrice } from "./LiveListItemPrice";
import { LiveListItemState } from "./LiveListItemState";
import { TicketPurchaseButton } from "./TicketPurchaseButton";

import type {
  EventVideo,
  Refference,
  Ticket,
} from "../../../../../../types/firebase/firestore";
import type { ResGetStreamingKey } from "../../../../../../types/functions";
import type { EventInfo } from "../../../../utility";

type Props = {
  videoTicket: Ticket & Refference;
  displayEvent: EventInfo;
  eventVideoMap: {
    [videoId: string]: EventVideo;
  } | null;
  streamingKey: ResGetStreamingKey;
  handleButtonAction: (ticketId: string | undefined) => void;
  handleButtonActionWithVideoTicket: (videoTicket: Ticket & Refference) => void;
};

export const EventVideoTicket: React.FC<Props> = (props) => {
  const classes = eventVideoTicketListDesign();
  const {
    eventVideoMap,
    displayEvent,
    streamingKey,
    videoTicket,
    handleButtonAction,
    handleButtonActionWithVideoTicket,
  } = props;
  const {
    isHiddenVODExpiredAt,
    isLotteryTicketSellingMode,
    _id: eventId,
  } = displayEvent;
  const defaultVideoId = extractDefaultVideoId(
    eventVideoMap,
    videoTicket.videoIds
  );
  // @ts-expect-error TS2538
  const video = eventVideoMap[defaultVideoId];
  // Boolean: ビデオを視聴出来るかどうか(チケットを持っているかどうか)判定する
  const canWatch = canWatchVideo(streamingKey, video?._id);
  // 新チケットページが有効なイベントは購入済みの判定を常にfalseにする
  const isPurchased =
    eventId &&
    isFeatureEnabled({
      featureName: "vspoExclusive",
      eventId,
    })
      ? false
      : canWatch &&
        videoTicket.videoIds.every((el) =>
          streamingKey?.videoIds?.includes(el)
        );
  // Boolean: チケットが販売期間中かどうか判定する
  const isOnSale =
    displayEvent.eventSaleStatus === "ON_SALE" &&
    isDisplayPeriod(
      videoTicket.display,
      videoTicket.releaseDateTime,
      videoTicket.closeDateTime
    );

  return (
    <div css={classes.videoItem}>
      <LiveListItemState ticket={videoTicket} />
      <div css={classes.ticketInfo}>
        <LiveListItemPrice canWatch={canWatch} ticket={videoTicket} />
        <LiveListItemCaution
          ticket={videoTicket}
          // @ts-expect-error TS2322
          isHiddenVODExpiredAt={isHiddenVODExpiredAt}
        />
        <TicketPurchaseButton
          {...{
            isPurchased,
            isOnSale,
            handleButtonAction,
            handleButtonActionWithVideoTicket,
            isLotteryTicketSellingMode,
            videoTicket,
          }}
        />
      </div>
    </div>
  );
};

const eventVideoTicketListDesign = () => {
  return {
    videoItem: css`
      width: 100%;
      border: 2px solid #d6d6d6;
      @media screen and (min-width: 768px) {
        width: 31%;
      }
      &:not(:last-child) {
        margin-bottom: 20px;
      }
    `,
    ticketInfo: css`
      padding: 16px;
    `,
  };
};
